module.exports = __webpack_public_path__ + "img/settings-2_960.7a732366.webp";